export class INetHandler {
  handle(cmd, body) {}
  name() {}
}
